"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterStatusBar = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var AttributeFilterFilteredStatus_1 = require("./AttributeFilterFilteredStatus");
var AttributeFilterSelectionStatus_1 = require("./AttributeFilterSelectionStatus");
/**
 * A component that displays status of current selection, like number of selected elements, if Attribute Filter is inverted and list of selected elements.
 *
 * @beta
 */
exports.AttributeFilterStatusBar = function (props) {
    var isFilteredByParentFilters = props.isFilteredByParentFilters, parentFilterTitles = props.parentFilterTitles, totalElementsCountWithCurrentSettings = props.totalElementsCountWithCurrentSettings, getItemTitle = props.getItemTitle, isInverted = props.isInverted, selectedItems = props.selectedItems, selectedItemsLimit = props.selectedItemsLimit;
    return (react_1.default.createElement("div", { className: "gd-attribute-filter-status-bar__next" },
        react_1.default.createElement(AttributeFilterSelectionStatus_1.AttributeFilterSelectionStatus, { isInverted: isInverted, getItemTitle: getItemTitle, selectedItems: selectedItems, selectedItemsLimit: selectedItemsLimit }),
        isFilteredByParentFilters && totalElementsCountWithCurrentSettings > 0 ? (react_1.default.createElement(AttributeFilterFilteredStatus_1.AttributeFilterFilteredStatus, { parentFilterTitles: parentFilterTitles })) : null));
};
//# sourceMappingURL=AttributeFilterStatusBar.js.map